import { Tooltip, Button, TextField, Box, FormControl, FormControlLabel, Grid, Input, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, InputAdornment } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IdentidadEjemplo from '../../participante/IdentidadEjemplo.jpg'
import Alert from '@mui/material/Alert';
import classes from "../ParticipanteClasess.css";
import { useState } from "react";
import Desplegable from "./Desplegable";
import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

export default function Aval2({ errorsEnviar, setErrors, formulario, onchange, handleblurAval, fechavaciaaval, setfechavaciaaval, selecteddateaval, setselecteddate, handleviviendaaval, selectedIdentidadAval2, setselectedIdentidadAval2}) {
    function CustomDatePicker(props) {
        const today = dayjs();
        const [invalidFormat, setInvalidFormat] = React.useState(false);
        const [cleared, setCleared] = React.useState(false);

        React.useEffect(() => {
            if (cleared) {
                setselecteddate(null);
                const timeout = setTimeout(() => {
                    setCleared(false);
                }, 1500);

                return () => clearTimeout(timeout);
            }
            return () => { };
        }, [cleared]);

        const handleDateChange = (date) => {
            if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
                setInvalidFormat(true);
            } else {
                setInvalidFormat(false);
                setselecteddate(date);
                setfechavaciaaval(false);
            }
        };

        const handleKeyDown = (event) => {
            event.preventDefault(); // Evitar la entrada manual
        };

        return (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                        format={"DD/MM/YYYY"}
                        value={selecteddateaval}
                        views={['year', 'month', 'day']}
                        //onChange={handleDateChange}
                        onAccept={handleDateChange}
                        slotProps={{
                            field: { clearable: true, onClear: () => setCleared(true) },
                            textField: {
                                helperText: fechavaciaaval ? 'Seleccione la fecha de nacimiento' : invalidFormat ? "Formato de fecha incorrecto" : (selecteddateaval && dayjs(selecteddateaval).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                                error: fechavaciaaval || invalidFormat,
                                onKeyDown: handleKeyDown
                            },
                        }}
                        maxDate={today}
                        {...props}
                    />
                </DemoItem>
                {cleared && (
                    <Alert
                        sx={{ position: 'absolute', bottom: 0, right: 0 }}
                        severity="success"
                    >
                        Fecha Borrada!
                    </Alert>
                )}
            </LocalizationProvider>

        );
    }

    const [civil, setCivil] = useState('');

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadAval2').click();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleChange = (event) => {
        setCivil(event.target.value);
    };

    const defaultProps = {
        options: listadepartamentos,
        getOptionLabel: (option) => option.title,
    };
    const flatProps = {
        options: listadepartamentos.map((option) => option.title),
    };

    const [value, setValue] = React.useState(null);

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloNumerosComa = (event) => {
        // Solo permitir números y el punto decimal
        event.target.value = event.target.value.replace(/[^0-9.]/g, '');

        // Asegurarse de que solo haya un punto decimal
        if (event.target.value.split('.').length > 2) {
            event.target.value = event.target.value.replace(/\.+$/, "");
        }

        // Formatear con comas
        const parts = event.target.value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        event.target.value = parts.join('.');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras, espacios y letras con acentos
        event.target.value = event.target.value.replace(/[^A-Za-zÁÉÍÓÚÜáéíóúü\s]/g, '');

        // Convertir a mayúsculas
        event.target.value = event.target.value.toUpperCase();
    };

    /*---------------------Validación Longitudes Y Campos Vacíos* ---------------*/

    const defaultPropsCivil = {
        options: listacivil,
        getOptionLabel: (option) => option.title,
    };
    const flatPropsCivil = {
        options: listacivil.map((option) => option.title),
    };

    return (
        <>
            <Box>
                <Stack direction="row">
                    <h3 >IV. DATOS PERSONALES - AVAL 2</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container spacing={1}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Identidad" label="Numero de Identidad" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 13 }}
                                error={Boolean(errorsEnviar.aval2Identidad)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Identidad} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Nombres" label="Nombres" variant="standard" onInput={validarSoloLetras}
                                error={Boolean(errorsEnviar.aval2Nombres)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Nombres} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Apellidos" label="Apellidos" variant="standard" onInput={validarSoloLetras}
                                error={Boolean(errorsEnviar.aval2Apellidos)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Apellidos} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}  >
                            <CustomDatePicker label="Fecha Nacimiento" id="aval2nacimiento" />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Profesion" label="Profesión u Oficio" variant="standard" onInput={validarSoloLetras}
                                error={Boolean(errorsEnviar.aval2Profesion)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Profesion} />
                        </FormControl>
                    </Grid>
                </Stack>


                <Stack className={classes.above} direction="row" >
                    <Grid container>
                        <Box >


                            <FormControl  >
                                <label>TIPO DE VIVIENDA</label>
                                <RadioGroup row aria-labelledby="Tipo Vivienda" name="tipoViviendaAval2" id="tipoViviendaAval2"
                                    onChange={handleviviendaaval}>
                                    <FormControlLabel value="Propia" control={<Radio color="error" />} label="Propia" />
                                    <FormControlLabel value="Familiar" control={<Radio color="error" />} label="Familiar" />
                                    <FormControlLabel value="Alquilada" control={<Radio color="error" />} label="Alquilada" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Grid>
                </Stack>

                <Stack className={classes.above} direction="row">
                    <Grid Container>

                        <Box>
                            <label>Direccion</label>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Barrio" label="Barrio/Col." variant="standard"
                                            error={Boolean(errorsEnviar.aval2Barrio)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Barrio} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Ave" label="Ave." variant="standard"
                                            error={Boolean(errorsEnviar.aval2Ave)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Ave} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Calle" label="Calle." variant="standard"
                                            error={Boolean(errorsEnviar.aval2Calle)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Calle} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Casa" label="Casa No." variant="standard"
                                            error={Boolean(errorsEnviar.aval2Casa)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Casa} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2Ciudad" label="Ciudad" variant="standard"
                                            error={Boolean(errorsEnviar.aval2Ciudad)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Ciudad} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <Autocomplete
                                            {...defaultProps}
                                            id="aval2Departamento"
                                            disableCloseOnSelect
                                            renderInput={(params) => (
                                                <TextField {...params} label="Departamento" variant="standard"
                                                    error={Boolean(errorsEnviar.aval2Departamento)}
                                                    onBlur={handleblurAval}
                                                    helperText={errorsEnviar.aval2Departamento} />
                                            )}
                                        />                                    </Box>
                                </Stack>
                            </Box>
                        </Box>
                        <Box>

                            <FormControl sx={{ m: 1, width: 300 }} >
                                <Autocomplete
                                    {...defaultPropsCivil}
                                    id="estadocivilAval2"
                                    disableCloseOnSelect
                                    renderInput={(params) => (
                                        <TextField {...params} label="Estado Civil" variant="standard"
                                            error={Boolean(errorsEnviar.estadocivilAval2)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.estadocivilAval2} />
                                    )}
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 800 }}>
                                <TextField id="aval2ReferenciaDomicilio" label="Referencia Domicilio" variant="standard"
                                    error={Boolean(errorsEnviar.aval2ReferenciaDomicilio)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2ReferenciaDomicilio} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Fijo" label="Teléfono Fijo" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                    error={Boolean(errorsEnviar.aval2Fijo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2Fijo} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval2Movil" label="Teléfono Movil" variant="standard" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                    error={Boolean(errorsEnviar.aval2Movil)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2Movil} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval2Correo" label="Correo Electrónico" variant="standard"
                                    error={Boolean(errorsEnviar.aval2Correo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2Correo} />
                            </FormControl>
                        </Box>
                    </Grid>
                </Stack>
            </Box>

            <Box>
                <Stack direction="row">
                    <h3 >V. INFORMACIÓN LABORAL - AVAL 2</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2Dependencia" label="Dependencia donde trabaja" variant="standard"
                                error={Boolean(errorsEnviar.aval2Dependencia)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Dependencia} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2Ramo" label="Ramo" variant="standard"
                                error={Boolean(errorsEnviar.aval2Ramo)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Ramo} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval2TelefonoTrabajo" label="Teléfono" variant="standard" inputProps={{ maxLength: 8 }} onInput={validarSoloNumeros}
                                error={Boolean(errorsEnviar.aval2TelefonoTrabajo)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2TelefonoTrabajo} />
                        </FormControl>
                        <Box>
                            <label>Dirección</label>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2BarrioTrabajo" label="Barrio/Col." variant="standard"
                                            error={Boolean(errorsEnviar.aval2BarrioTrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2BarrioTrabajo} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2AveTrabajo" label="Ave." variant="standard"
                                            error={Boolean(errorsEnviar.aval2AveTrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2AveTrabajo} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CalleTrabajo" label="Calle" variant="standard"
                                            error={Boolean(errorsEnviar.aval2CalleTrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2CalleTrabajo} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CasaTrabajo" label="Casa No." variant="standard"
                                            error={Boolean(errorsEnviar.aval2CasaTrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2CasaTrabajo} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval2CiudadTrabajo" label="Ciudad" variant="standard"
                                            error={Boolean(errorsEnviar.aval2CiudadTrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2CiudadTrabajo} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <Autocomplete
                                            {...defaultProps}
                                            id="aval2Departamentotrabajo"
                                            disableCloseOnSelect
                                            renderInput={(params) => (
                                                <TextField {...params} label="Departamento" variant="standard"
                                                    error={Boolean(errorsEnviar.aval2Departamentotrabajo)}
                                                    onBlur={handleblurAval}
                                                    helperText={errorsEnviar.aval2Departamentotrabajo} />
                                            )}
                                        />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>

                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoMensualAval2" label="Sueldo Mensual" onInput={validarSoloNumeros} variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                            }}
                                error={Boolean(errorsEnviar.sueldoMensualAval2)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.sueldoMensualAval2} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="otrosIngresosAval2" label="Otros ingresos (detalle)" onInput={validarSoloNumeros} variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                            }}
                                error={Boolean(errorsEnviar.otrosIngresosAval2)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.otrosIngresosAval2} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoNetoAval2" label="Sueldo Neto" onInput={validarSoloNumeros} variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                            }}
                                error={Boolean(errorsEnviar.sueldoNetoAval2)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.sueldoNetoAval2} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval2Puesto" label="Puesto" variant="standard"
                                error={Boolean(errorsEnviar.aval2Puesto)}
                                onBlur={handleblurAval}
                                helperText={errorsEnviar.aval2Puesto} />
                        </FormControl>
                        <Box>
                            <Box>
                                <label>Tiempo De Laborar</label>
                            </Box>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Years" label="Años" variant="standard"
                                    error={Boolean(errorsEnviar.aval2Years)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2Years} />
                            </FormControl>

                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval2Meses" label="Meses" variant="standard"
                                    error={Boolean(errorsEnviar.aval2Meses)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2Meses} />
                            </FormControl>
                        </Box>
                    </Grid>

                </Stack>
            </Box>

            <Box marginTop={5}>
                {<h3>COPIA DE LA IDENTIDAD EN FORMATO PDF DEL AVAL 2</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverIdentidadSoli}
                    onDrop={handleDropIdentidadSoli}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: '700px',
                            textAlign: 'center',
                            borderColor: selectedIdentidadAval2 ? 'green' : '#a0a0a0',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <Tooltip
                            title={
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{fontSize: 15, textAlign: 'justify'}}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            }
                            interactive
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                        </Tooltip>
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickIdentidadSoli}
                            style={{ marginTop: '10px', backgroundColor: '#ECECEC'}}
                        >
                            Seleccionar Identidad En PDF
                        </Button>
                        <input
                            id="selectedIdentidadAval2"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeIdentidadSoli}
                        />
                        {!selectedIdentidadAval2 && <p>Seleccione el archivo PDF o Arrástrelo dentro del contenedor</p>}
                        {selectedIdentidadAval2 && <p>Archivo seleccionado: {selectedIdentidadAval2.name}</p>}
                    </Box>
                </Box>
            </Box>
        </>
    );
}

const listadepartamentos = [
    { title: 'Atlantida',  },
    { title: 'Colón',  },
    { title: 'Comayagua',  },
    { title: 'Copán',  },
    { title: 'Cortés',  },
    { title: 'Choluteca',  },
    { title: 'El Paraíso',  },
    { title: 'Francisco Morazán',  },
    { title: 'Gracias A Dios',  },
    { title: 'Intibucá',  },
    { title: 'Islas De La Bahía',  },
    { title: 'La Paz',  },
    { title: 'Lempira',  },
    { title: 'Ocotepeque',  },
    { title: 'Olancho',  },
    { title: 'Santa Bárbara',  },
    { title: 'Valle',  },
    { title: 'Yoro',  },
];

const listacivil = [
    { title: 'Soltero',  },
    { title: 'Casado',  },
    { title: 'Viudo',  },
    { title: 'Divorciado',  },
    { title: 'Unión Libre',  },
];
